/**
 * Função principal para buscar e carregar informações de produtos.
 * @param {HTMLElement|Document} container - O elemento pai onde buscar os cards (padrão: document)
 */
export function refreshProductInfo(container = document) {
    // 1. Busca apenas cards que ainda não foram processados (evita fetch duplicado)
    const products = container.querySelectorAll('.product-card:not([data-info-loaded="true"])');
    const codes = [];

    products.forEach(el => {
        const code = el.dataset.productCode;
        if (code) {
            codes.push(code);
            // Marca como "em carregamento" para evitar que outra chamada paralela o pegue
            el.setAttribute('data-info-loaded', 'true');
        }
    });

    if (!codes.length) return;

    fetch(window.routes.productInfo + `?` + new URLSearchParams({ codes: codes }))
        .then(res => res.json())
        .then(data => {
            products.forEach(el => {
                const code = el.dataset.productCode;
                const info = data[code];
                if (!info) return;

                const actions = el.querySelector('.product-actions');
                const priceEl = el.querySelector('.price');

                // Atualiza Preço
                if (priceEl) {
                    priceEl.classList.remove('price-loading');
                    priceEl.innerText = 'R$ ' + info.price;
                }

                // Atualiza Botão de Ação
                if (actions) {
                    renderButton(actions, code, info.stock);
                }
            });
        })
        .catch(err => {
            // Em caso de erro, remove a marcação para permitir tentar novamente depois
            products.forEach(el => el.removeAttribute('data-info-loaded'));
            console.error("Erro ao carregar info dos produtos:", err);
        });
}

// Função auxiliar para renderizar o HTML do botão
function renderButton(container, code, stock) {
    if (stock > 0) {
        container.innerHTML = `
            <button type="button" class="btn-kart mobilebtn-kart btn btn-primary btn-add-quick" 
                    data-product-code="${code}"
                    onclick="event.preventDefault(); event.stopPropagation();">
                <img src="${window.routes.home}/site/img/icons/kart-add.svg" alt="">
                <span>Adicionar</span>
            </button>`;
    } else {
        container.innerHTML = `
            <button type="button" class="btn-kart btn btn-secondary" disabled>
                Sem estoque
            </button>`;
    }
}

// Inicialização padrão
export default function loadProductInfo() {
    document.addEventListener('DOMContentLoaded', () => refreshProductInfo());
}